import validate from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@9.29.0_jiti@2.4._4c1478ec399f92e617c628ccbaf39e85/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/auth.global.js";
import manifest_45route_45rule from "/data/runners/seven/_work/apps-monorepo/apps-monorepo/node_modules/.pnpm/nuxt@3.15.0_@parcel+watcher@2.5.1_@types+node@20.19.1_db0@0.3.2_eslint@9.29.0_jiti@2.4._4c1478ec399f92e617c628ccbaf39e85/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "company-guard": () => import("/data/runners/seven/_work/apps-monorepo/apps-monorepo/apps/pay/middleware/companyGuard.js")
}